import React from "react";
import { useDispatch } from "react-redux";
import { useForm, Controller } from "react-hook-form";
import { TextField, Button, Typography, Box } from "@mui/material";
import { createCategory } from "../redux/Slices/CategorySlice";
import toast, { Toaster } from "react-hot-toast";

const AddCategoriesPage = () => {
  <Toaster
    position="top-center"
    reverseOrder={false}
    gutter={8}
    containerClassName=""
    containerStyle={{}}
    toastOptions={{
      className: "",
      duration: 5000,
      removeDelay: 1000,
      style: {
        background: "#36366",
        color: "#fff",
      },

      success: {
        duration: 3000,
        iconTheme: {
          primary: "green",
          secondary: "black",
        },
      },
    }}
  />;
  const dispatch = useDispatch();
  const {
    handleSubmit,
    control,
    reset,
    formState: { errors },
  } = useForm({
    defaultValues: {
      name: "",
      description: "",
    },
  });

  const onSubmit = (data) => {
    dispatch(createCategory(data));

    try {
      toast.success("Category created successfully");
      reset();
    } catch (error) {
      toast.error(`Failed to create category: ${error}`);
    }
  };

  return (
    <>
      <Toaster />
      <div className="pl-5">
        <Box
          component="form"
          onSubmit={handleSubmit(onSubmit)}
          sx={{
            maxWidth: 400,
            mx: "auto",
            p: 3,
            boxShadow: 3,
            borderRadius: 2,
            backgroundColor: "#fff",
          }}
        >
          <Typography variant="h5" mb={2}>
            Create New Category
          </Typography>

          {/* Name  */}
          <Controller
            name="name"
            control={control}
            rules={{
              required: "Name is required",
            }}
            render={({ field }) => (
              <TextField
                {...field}
                label="Category Name"
                fullWidth
                margin="normal"
                error={!!errors.name}
                helperText={errors.name?.message}
              />
            )}
          />

          <Button
            type="submit"
            variant="contained"
            color="primary"
            fullWidth
            sx={{ mt: 2 }}
          >
            Create Category
          </Button>
        </Box>
      </div>
    </>
  );
};

export default AddCategoriesPage;
